import styled, { css } from 'styled-components';
import {
  fillFlatNewIconWithColor,
  fillVillaIconWithColor,
  FlexCenteredColumn,
  transitionStyles
} from '../../styled/common';
import { Typography } from '../ui/Typography';

const containerStateStyles = (color: string, isLeasedOption: boolean) => css`
  border-color: ${({ theme }) => theme.colors.systemColors.blue};
  ${transitionStyles('border-color')}

  span {
    ${transitionStyles('color')}
    color: ${color};
  }

  &:nth-of-type(1),
  &:nth-of-type(4),
  &:nth-of-type(6),
  &:nth-of-type(7) {
    svg path,
    svg rect {
      ${transitionStyles('stroke')}
      stroke: ${color};
    }
  }

  &:nth-of-type(2) {
    ${fillFlatNewIconWithColor(color)};
  }

  &:nth-of-type(3) {
    ${fillVillaIconWithColor(color)};
  }

  &:nth-of-type(5) {
    svg path {
      fill: ${color};
      ${transitionStyles('fill')}
    }
  }

  ${isLeasedOption &&
  css`
    &:nth-of-type(1),
    &:nth-of-type(2) {
      svg path,
      svg rect {
        fill: ${color};
        ${transitionStyles('fill')}
      }
    }
  `}
`;

export const StepModalOption = styled(FlexCenteredColumn)<{
  $isLeasedOption?: boolean;
}>`
  background-color: ${({ theme }) => theme.colors.background.tertiary};
  border-radius: 14px;
  border: 1px solid ${({ theme }) => theme.colors.border.secondary};
  padding: 30px 15px;
  gap: 15px;
  cursor: pointer;

  @media (hover: hover) {
    &:hover {
      ${({ theme, $isLeasedOption }) =>
        containerStateStyles(theme.colors.systemColors.blue, $isLeasedOption)};
    }
  }
`;

export const StepModalOptionText = styled(Typography)``;
